import { render } from "./walletMenuLayer2PcIndex.vue?vue&type=template&id=4f5c275b"
import script from "./walletMenuLayer2PcIndex.vue?vue&type=script&lang=js"
export * from "./walletMenuLayer2PcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__